import React from "react";
import { TripleNumberInput } from "../../../components/triple-number-input/TripleNumberInput.component";
import { useTranslation } from "react-i18next";
import { LabelledElement } from "../../../components/labelled-element/LabelledElement.component";
export var ModelUploadContentUtils;
(function (ModelUploadContentUtils) {
    function createTripleNumberInputPosition(value, onChange) {
        const { t } = useTranslation();
        return (React.createElement(LabelledElement, { label: t("upload:triple-input-position-label", "Position (in m):") },
            React.createElement(TripleNumberInput, { labels: ["X:", "Y:", "Z:"], tooltips: [
                    t("upload:triple-input-position-x-tooltip", "The position along the worlds x-axis"),
                    t("upload:triple-input-position-y-tooltip", "The position along the worlds y-axis"),
                    t("upload:triple-input-position-z-tooltip", "The position along the worlds z-axis")
                ], value: value, onChange: onChange })));
    }
    ModelUploadContentUtils.createTripleNumberInputPosition = createTripleNumberInputPosition;
    function createTripleNumberInputRotation(value, onChange) {
        const { t } = useTranslation();
        return (React.createElement(LabelledElement, { label: t("upload:triple-input-rotation-label", "Rotation (in degrees):") },
            React.createElement(TripleNumberInput, { labels: ["X:", "Y:", "Z:"], tooltips: [
                    t("upload:triple-input-rotation-x-tooltip", "The rotation around the worlds x-axis"),
                    t("upload:triple-input-rotation-y-tooltip", "The rotation around the worlds y-axis"),
                    t("upload:triple-input-rotation-z-tooltip", "The rotation around the worlds z-axis")
                ], value: value, onChange: onChange })));
    }
    ModelUploadContentUtils.createTripleNumberInputRotation = createTripleNumberInputRotation;
})(ModelUploadContentUtils || (ModelUploadContentUtils = {}));
